module.exports = __webpack_public_path__ + "img/expostyle_0036_cocos.1e1ee09a.jpg";